import { freebiesSellersQuery } from "/app/src/routes/{-$locale}/freebies/sellers.tsx?tsr-shared=1";
const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/freebies/sellers.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import i18n from "@/lib/i18n";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/freebies/sellers")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context
  }) => {
    const {
      queryClient
    } = context;
    await queryClient.prefetchQuery(freebiesSellersQuery);
  }
});
type SortDirection = "asc" | "desc";